import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const AccordionItem = () => _jsx(_Fragment, {});
export default AccordionItem;
